import { useEffect, useState } from 'react';
// eslint-disable-next-line import/named
import 'react-toastify/dist/ReactToastify.css';
import { Article, ArticleResponse } from '../services/coworkerApiCalls/Article/ArticlesTypes';
import { getArticleByCategoryBySpace, getArticleById, getArticles, getArticlesByCategory, getArticlesByCategoryBySpace } from '../services/coworkerApiCalls/Article/Article';
import { articleResponseToArticle, articleResponsesToArticles } from '../services/helpers/ArticleMapper';
import { useOktaAuth } from '@okta/okta-react';
import { ID_SPACE } from '../constant';

function useDataApiArticle(id: number) {
    const [article, setArticle] = useState<Article>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {
            const articleTemporary: Article = await getArticleById(token, id);
            const articleResult: ArticleResponse = articleResponseToArticle(articleTemporary);
            setArticle(articleResult);
        };
        void getUsers();

    }, [id, token]); // Or [] if effect doesn't need props or state
    
    return article;
}


function useDataApiArticleByCategoryBySpace(categoryId:number) {
    const [article, setArticle] = useState<Article>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {
            const articleTemporary: Article = await getArticleByCategoryBySpace(token, categoryId, ID_SPACE);
            const articleResult: ArticleResponse = articleResponseToArticle(articleTemporary);
            setArticle(articleResult);
        };
        void getUsers();

    }, [token,  categoryId]); // Or [] if effect doesn't need props or state


    return article;
}

function useDataApiArticles() {
    const [article, setArticle] = useState<Article[]>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const articlesTemporary: Article[] = await getArticles(token);
            const articlesResult: ArticleResponse[] = articleResponsesToArticles(articlesTemporary);
            setArticle(articlesResult);

        };
        void getUsers();

    }, [token]); // Or [] if effect doesn't need props or state


    return article;
}


function useDataApiArticlesByCategory(categoryId:number) {
    const [article, setArticle] = useState<Article[]>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const articlesTemporary: Article[] = await getArticlesByCategory(token, categoryId);
            const articlesResult: ArticleResponse[] = articleResponsesToArticles(articlesTemporary);
            setArticle(articlesResult);

        };
        void getUsers();

    }, [token, categoryId]); // Or [] if effect doesn't need props or state


    return article;
}

function useDataApiArticlesByCategoryBySpace(categoryId:number) {
    const [article, setArticle] = useState<Article[]>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {
            const articlesTemporary: Article[] = await getArticlesByCategoryBySpace(token, categoryId, ID_SPACE);
            const articlesResult: ArticleResponse[] = articleResponsesToArticles(articlesTemporary);
            setArticle(articlesResult);
        };
        void getUsers();

    }, [token, categoryId]); // Or [] if effect doesn't need props or state


    return article;
}


export { useDataApiArticle, useDataApiArticles, useDataApiArticlesByCategory, useDataApiArticlesByCategoryBySpace, useDataApiArticleByCategoryBySpace }